import { render, staticRenderFns } from "./Move.vue?vue&type=template&id=3f89407b&scoped=true&"
import script from "./Move.vue?vue&type=script&lang=js&"
export * from "./Move.vue?vue&type=script&lang=js&"
import style0 from "./Move.vue?vue&type=style&index=0&id=3f89407b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f89407b",
  null
  
)

export default component.exports